import { Autocomplete, Box, Button, Drawer, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import '../reports.css';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { CommonGridToolBarWithFilterText, CommonTimeRangePicker } from "../../../../Components/Common Components/CommonComponents";
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { AmountFormat, formatDate, timeOnlyConvert } from "../../../../Components/CommonFunctions/CommonFunctions";
import { DateTime } from 'luxon';
import { CurrencySymbol } from '../../../../Utility/Constants';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';


class ServiceOverview extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            doctorName: [],
            serviceName: [],
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            dateIndex: 1,
            serviceOverviewData: [],
            serviceTotalAmount: "",
            serviceDiscountAmount: "",
            serviceNetAmount: "",
            serviceDoctorName: [],
            serviceNameAndType: [],
            FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilterDatas: {
                "startTime": null,
                "endTime": null,
                "onError": false,
            },
            timeError: false,
            serviceHeads: [], // List of Service Heads
            isNewBilling: false,
            isBillDoctor: false,
            serviceType:[],
            allServices:[],
        }
    }

    componentDidMount() {
        let patientData = JSON.parse(localGetItem("loggedInUserInfo"))
        let isBillDoctor = patientData?.bill_doctor_enabled ? patientData?.bill_doctor_enabled : false
        this.setState({ isBillDoctor: isBillDoctor })
        this.getServiceOverviewDetails()
        this.getServiceFilterDoctorList()
        this.setState({ isNewBilling: localGetItem("isNewBilling") === "true" }, () => {
            if (this.state.isNewBilling) {
                this.getModuleList()
            } else {
                this.getServiceNameAndTypeFilterList()
            }
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    onChangeHandler = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        }, () => {
            this.state.FilterDatas.endTime = null
            this.setState({
                FilterDatas: this.state.FilterDatas
            })
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

   getServiceOverviewDetails = () => {
    try {
        this.LoaderFunction(true)
        let doctorId = [];
        this.state.doctorName.forEach(element => doctorId.push(element.doctor_id))
        let selectedHeads = this.state.serviceType || [];
        let selectedNames = this.state.serviceName || [];
        let serviceTypes = [];
        let serviceNames = [];
       if (this.state.isNewBilling) {
            serviceTypes = selectedHeads.map(h => h);
            serviceNames = selectedNames.map(sn => sn.service_name); 
        } else {
            serviceTypes = selectedHeads; 
            serviceNames = selectedNames.map(sn => sn.service_name);
        }
        let serviceTypesQuery = serviceTypes.length > 0 ? encodeURIComponent(serviceTypes.join(",")) : "";
        let serviceNamesQuery = serviceNames.length > 0 ? encodeURIComponent(serviceNames.join(",")) : "";
        var { FilterDatas } = this.state
        let start_time = FilterDatas.startTime ? new Date(FilterDatas.startTime) : ''
        let end_time = FilterDatas.endTime ? new Date(FilterDatas.endTime) : ''
        let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        const baseUrl = localGetItem('isNewBilling') === "true"
            ? Serviceurls.NEW_FO_REPORTS_SERVICE_OVERVIEW
            : Serviceurls.FO_REPORTS_SERVICE_OVERVIEW;
        const apiUrl = `${baseUrl}?doctor_id=${doctorId.join(",")}&service_type=${serviceTypesQuery}&service_name=${serviceNamesQuery}&from_date=${this.state.fromDate}&to_date=${this.state.toDate}&start_time=${setStartTime}&end_time=${setEndTime}`;
        RestAPIService.getAll(apiUrl)
            .then(response => {
                if (response.data.status === "success") {
                    this.setState({
                        serviceOverviewData: response.data.data,
                        serviceTotalAmount: response.data.total_amount,
                        serviceDiscountAmount: response.data.total_discount_amount,
                        serviceNetAmount: response.data.total_net_amount,
                        FilteredFromDate: this.state.fromDate,
                        FilteredToDate: this.state.toDate,
                    }, () => { this.LoaderFunction(false) })
                }
            }).catch((error) => {
                       this.LoaderFunction(false)
                       if (error?.response?.data?.status === 'fail') {
                           this.errorMessage(error.response.data.message)
                       } else {
                           this.errorMessage(error.message)
                       }
                   })
    } catch (error) {
        this.LoaderFunction(false)
        this.errorMessage(error.message)
    }
}
    printReports = () => {
        try {
            let doctorId = []; let serviceName = []; let serviceType = [];
            this.state.doctorName.forEach(element => doctorId.push(element.doctor_id))
            if (this.state.isNewBilling) {
                this.state.serviceName.forEach(element => serviceName.push(element.service_name))
                serviceType = this.state.serviceType.map(h => h);
            } else {
                this.state.serviceName.forEach(element => serviceName.push(element?.service_name))
                // serviceName = this.state.serviceName.map(h => h?.serviceName);
                this.state.serviceType.forEach(element => serviceType.push(element))
            }
            var { FilterDatas } = this.state
            let start_time = FilterDatas.startTime ? new Date(FilterDatas.startTime) : ''
            let end_time = FilterDatas.endTime ? new Date(FilterDatas.endTime) : ''
            let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            const baseUrl = localGetItem('isNewBilling') === "true" ? Serviceurls.NEW_FO_REPORTS_SERVICE_OVERVIEW : Serviceurls.FO_REPORTS_SERVICE_OVERVIEW;
            RestAPIService.getAll(`${baseUrl}?doctor_id=${doctorId}&service_type=${serviceType ? encodeURIComponent(serviceType) : ""}&service_name=${serviceName ? encodeURIComponent(serviceName) : ""}&from_date=${this.state.fromDate}&to_date=${this.state.toDate}&export_type=pdf&start_time=${setStartTime}&end_time=${setEndTime}`)
                .then((response) => {
                    if (response) {
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        const fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }
    getServiceFilterDoctorList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            serviceDoctorName: response.data.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getServiceNameAndTypeFilterList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSRCNAME)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            serviceNameAndType: response.data.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }

    selectedTime = (start, end, error) => {
        this.state.FilterDatas.startTime = start
        this.state.FilterDatas.endTime = end
        this.setState({ FilterDatas: this.state.FilterDatas, timeError: error })
    }


   getModuleList = () => {
    try {
        let serviceHeads = [];
        let allServices = [];

        RestAPIService.getAll(Serviceurls.NEW_SERVICE_LIST_REPORT)
            .then((response) => {
                if (response.data.status === 'success') {
                    const moduleData = response.data.data || {};

                    Object.keys(moduleData).forEach(moduleType => {
                        if (moduleType === "IP") return; // Exclude IP
                        moduleData[moduleType].forEach((item) => {
                            const { head_name, service_details = [] } = item;
                            if (!serviceHeads.some(h => h.head_name === head_name)) {
                                serviceHeads.push({ head_name });
                            }
                            service_details.forEach(s => {
                                if (!allServices.some(a => a.service_name === s.service_name)) {
                                    allServices.push({
                                        service_name: s.service_name,
                                        head_name: head_name
                                    });
                                }
                            });
                        });
                    })
                    this.setState({ serviceHeads, allServices });
                }
            })
            .catch((error) => {
                const errorMessage = error?.response?.data?.message || error?.message || "An unknown error occurred";
                this.errorMessage(errorMessage);
            });
    } catch (error) {
        this.errorMessage(error.message);
    }
};

    // handleServiceHeadChange = (event, newValue) => {
    //     this.setState({
    //         serviceName: newValue, // Update selected service heads
    //     });
    // };

    renderFilterScreen = () => {
        const { t } = this.props
        const other_consultant_name = "Others";
        const other_consultant_type = "Consultation Other";
        let serviceTypeList = []; let NewServiceType = [];
        this.state.serviceNameAndType.map((item) => item.data.map((data) => serviceTypeList.push(data.service_name)))
        this.state.serviceNameAndType.map((item) => NewServiceType.push(item.service_type))
        let uniqueArray = [...new Set(serviceTypeList)]
        let serviceTypeUnique = [...new Set(NewServiceType)]
        uniqueArray.push(other_consultant_name);
        serviceTypeUnique.push(other_consultant_type);
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    <Box sx={{ width: '22vw' }}>
                        <CommonTimeRangePicker
                            startTime={this.state.FilterDatas?.startTime}
                            endTime={this.state.FilterDatas?.endTime}
                            selectedTime={this.selectedTime.bind(this)}
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            onError={this.state.FilterDatas.onError}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            options={this.state.serviceDoctorName?.map((item) => item)}
                            getOptionLabel={(option) => (option?.doctor_name)}
                            value={this.state.doctorName}
                            onChange={(event, newValue) => {
                                const length = this.state.doctorName.length;
                                this.setState({ doctorName: newValue }, () => {
                                    if (newValue.length < length) {
                                        this.getServiceOverviewDetails();
                                    }
                                });
                            }}
                            renderOption={(props, option) => (
                                <li {...props} key={option?.doctor_id}>
                                    {option?.doctor_name}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('selectDoctor')}
                                    sx={{
                                        '& .MuiInputBase-input::placeholder': {
                                            color: 'black',
                                            opacity: "0.7",
                                        },
                                    }}
                                />
                            )}
                        />
                    </Box>
                    {this.state.isNewBilling ?
                        <>
                            <Box className='eMed_rts_dropdown'>
                                <Autocomplete
                                    multiple
                                    limitTags={1}
                                    size='small'
                                    options={this.state.serviceHeads.map(h => h.head_name)}
                                    value={this.state.serviceType}
                                    onChange={(event, newValue) => {
                                        const prevLength = this.state.serviceType.length;
                                        this.setState({ serviceType: newValue, serviceName: [] }, () => {
                                            if (newValue.length < prevLength) {
                                                this.getServiceOverviewDetails();
                                            }
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t("Select Service Head")}
                                            sx={{
                                                "& .MuiInputBase-input::placeholder": {
                                                    color: "black",
                                                    opacity: 0.7,
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </Box>
                            <Box className='eMed_rts_dropdown'>
                                <Autocomplete
                                    multiple
                                    limitTags={1}
                                    size="small"
                                    options={
                                        this.state.serviceType.length > 0
                                            ? this.state.allServices.filter(s =>
                                                this.state.serviceType.includes(s.head_name)
                                            )
                                            : this.state.allServices
                                    }
                                    getOptionLabel={(option) => option?.service_name ?? ""}
                                    value={this.state.serviceName}
                                    onChange={(event, newValue) => {
                                        const prevLength = this.state.serviceName.length;
                                        this.setState({ serviceName: newValue }, () => {
                                            if (newValue.length < prevLength) {
                                                this.getServiceOverviewDetails();
                                            }
                                        });
                                    }}
                                    isOptionEqualToValue={(opt, val) =>
                                        opt.service_name === val.service_name
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            emed_tid={"selectServiceTestID"}
                                            label={t("Select Service Name")}
                                            sx={{
                                                "& .MuiInputBase-input::placeholder": {
                                                    color: "black",
                                                    opacity: 0.7,
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </Box>
                        </>
                        :
                        <>
                            <Box className='eMed_rts_dropdown'>
                                <Autocomplete
                                    multiple
                                    limitTags={1}
                                    size='small'
                                    options={serviceTypeUnique}
                                    getOptionLabel={(option) => (option)}
                                    value={this.state.serviceType}
                                    onChange={(event, newValue) => {
                                        const prevLength = this.state.serviceType.length;
                                        this.setState({ serviceType: newValue, serviceName: [] }, () => {
                                            if (newValue.length < prevLength) {
                                                this.getServiceOverviewDetails();
                                            }
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t("Select Service type")}
                                            emed_tid={"selectServiceTestID"}
                                            sx={{
                                                "& .MuiInputBase-input::placeholder": {
                                                    color: "black",
                                                    opacity: 0.7,
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </Box>
                            <Box className='eMed_rts_dropdown'>
                                <Autocomplete
                                    multiple
                                    limitTags={1}
                                    size='small'
                                    options={(() => {
                                        const selectedHeads = this.state.serviceType;
                                        let filteredServices = [];

                                        if (!selectedHeads.length) {
                                            filteredServices = this.state.serviceNameAndType.flatMap(item =>
                                                item.data?.map(srv => ({ service_name: srv.service_name })) || []
                                            );
                                        } else {
                                            this.state.serviceNameAndType.forEach(item => {
                                                if (selectedHeads.includes(item.service_type)) {
                                                    item.data?.forEach(srv => {
                                                        filteredServices.push({ service_name: srv.service_name });
                                                    });
                                                }
                                            });
                                        }
                                        const uniqueServices = Array.from(
                                            new Map(filteredServices.map(srv => [srv.service_name, srv])).values()
                                        );

                                        return uniqueServices;
                                    })()}
                                    getOptionLabel={(option) => option?.service_name || ""}
                                    value={this.state.serviceName}
                                    onChange={(event, newValue) => {
                                        const prevLength = this.state.serviceName.length;
                                        this.setState({ serviceName: newValue }, () => {
                                            if (newValue.length < prevLength) {
                                                this.getServiceOverviewDetails();
                                            }
                                        });
                                    }}
                                    isOptionEqualToValue={(option, value) => option.service_name === value.service_name}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t("Select Service Name")}
                                            emed_tid = {"selectServiceTestID"}
                                            sx={{
                                                "& .MuiInputBase-input::placeholder": {
                                                    color: "black",
                                                    opacity: 0.7,
                                                },
                                            }}
                                        />
                                    )}
                                />

                            </Box>
                        </>

                    }
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            this.setState({
                                doctorName: [],
                                serviceName: [],
                                serviceType:[],
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                FilterDatas: {
                                    "startTime": null,
                                    "endTime": null,
                                    "onError": false,
                                },
                                timeError: false,
                            },
                                () => this.getServiceOverviewDetails())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        disabled={this.state.FilterDatas.startTime ? (this.state.FilterDatas.startTime && this.state.FilterDatas.endTime && this.state.timeError != true) ? false : true : false}
                        onClick={() => {
                            this.getServiceOverviewDetails()
                            this.setState({ FilterOpen: false })
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }
    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }
    gridToolBar = () => {
        let start_time = this.state.FilterDatas.startTime ? new Date(this.state.FilterDatas.startTime) : ''
        let end_time = this.state.FilterDatas.endTime ? new Date(this.state.FilterDatas.endTime) : ''
        let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.FilteredFromDate) },
            { label: "To Date", value: formatDate(this.state.FilteredToDate) },
        ]
        if (this.state.FilterDatas.startTime !== null && this.state.FilterDatas.endTime !== null) {
            TextArray.push(
                { label: "Start Time", value: timeOnlyConvert(setStartTime) },
                { label: "End Time", value: timeOnlyConvert(setEndTime) }
            )
        }
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
            </Box>

        )
    }
    render() {
        this.state.serviceOverviewData.forEach((element, index) => element.sno = index + 1)
        const { t } = this.props
        const columns = [
            {
                field: "doctor_name", headerName: t("DoctorName"), flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.doctor_name?.length > 22 ?
                    <Tooltip placement='top' title={params?.row?.doctor_name} arrow><div>{params?.row?.doctor_name.slice(0, 22) + "..."}</div></Tooltip>
                    : params?.row?.doctor_name ? params?.row?.doctor_name : "-"}</Box>)
            },
            {
                field: "nurse_name", headerName: t("NurseName"), flex: 0.15, hide: (this.state.isBillDoctor ? true : false),
                renderCell: (params) => (<Box component={'div'}>{params?.row?.nurse_name?.length > 22 ?
                    <Tooltip placement='top' title={params?.row?.nurse_name} arrow><div>{params?.row?.nurse_name.slice(0, 22) + "..."}</div></Tooltip>
                    : params?.row?.nurse_name ? params?.row?.nurse_name : "-"}</Box>)
            },
            {
                field: "service_type", headerName: localGetItem("isNewBilling") === "false" ? t("ServiceType") : t("Service Head"), flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.service_type?.length > 22 ?
                    <Tooltip placement='top' title={params?.row?.service_type} arrow><div>{params?.row?.service_type.slice(0, 22) + "..."}</div></Tooltip>
                    : params?.row?.service_type ? params?.row?.service_type : "-"}</Box>)
            },
            {
                field: "service_name", headerName: t("ServiceName"), flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.service_name?.length > 22 ?
                    <Tooltip placement='top' title={params?.row?.service_name} arrow><div>{params?.row?.service_name.slice(0, 22) + "..."}</div></Tooltip>
                    : params?.row?.service_name ? params?.row?.service_name : "-"}</Box>)
            },
            {
                field: "count", headerName: t("Count"), flex: 0.06, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.count ? params?.row?.count : "-"}</Box>
                )
            },
            {
                field: "total_amount", headerName: t("Total Amount"), flex: 0.10, type: "number",
                renderCell: (params) => (
                    <Box component={'div'}>{params?.row?.total_amount ? AmountFormat(params?.row?.total_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>
                )
            },
            {
                field: "discount_amount", headerName: `${t("ConcessionAmt")} (${CurrencySymbol})`, flex: 0.10, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.discount_amount ? AmountFormat(params?.row?.discount_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            // {
            //     field: "remarks", headerName: `${t("Discount Reason")}`, flex: 0.166, type: "number",
            //     renderCell: (params) => (<Box component={'div'}>{params?.row?.remarks ?
            //         params?.row?.remarks?.length > 15 ?
            //             <Tooltip placement='top' title={params?.row?.remarks}><div>{params?.row?.remarks.slice(0, 15) + '...'}</div></Tooltip> :
            //             params?.row?.remarks : "-"}</Box>)
            // },
            {
                field: "discounted_amount", headerName: `${t("Amount")} (${CurrencySymbol})`, flex: 0.10, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.discounted_amount ? AmountFormat(params?.row?.discounted_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            }
        ]

        if (this.state.isBillDoctor) {
            let billedDoc = {
                field: "bill_doctor", headerName: t("Billed Doctor"), flex: 0.143,
                renderCell: ({ row }) => {
                    const billDoctor = row?.bill_doctor?.trim();
                    return (<Box component={'div'}>{billDoctor?.length > 20 ?
                        <Tooltip placement='top' title={billDoctor} arrow><div>{billDoctor?.slice(0, 20) + "..."}</div></Tooltip>
                        : billDoctor ? billDoctor : "-"}</Box>)
                }
            }
            columns.splice(2, 0, billedDoc)
        }

        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                        {AmountsCard(t("TotalAmount"), this.state.serviceTotalAmount)}
                        {AmountsCard(t("Concession Amount"), this.state.serviceDiscountAmount)}
                        {AmountsCard(t("Net Amount"), this.state.serviceNetAmount)}
                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className='eMed_Filter_Icon_div'>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        </Box>
                        <Button className='eMed_usrconf_btn' onClick={() => { this.printReports() }}>
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                        </Button>
                        {/* <Button className='eMed_usrconf_btn'>
                            <img src={ImagePaths.LabUploadButton.default} alt="upload" className='eMed_action_img' />
                        </Button> */}
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.serviceOverviewData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                        loading={this.state.isLoader}
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}


export default withTranslation()(ServiceOverview)